import { ProductService } from './services/product/productService';
import { SDKConfig } from './interfaces/configuration';
import { configuration, envs } from './configuration';
import { Auth } from './auth/auth';
import { CartService } from './services/cart/cartService';
import {
  AddressDetails,
  AddressFetch,
  AddressQuery,
  AddressSearch,
  Cart,
  Checkout,
  CreateCheckout,
  Prediction,
  Product,
  ProductSearchParams,
  UpdateCart,
} from './api';
import { CheckoutService } from './services/checkout/checkoutService';
import { AddressService } from './services/address/addressService';

export class Liquid {
  private readonly cartService = new CartService();
  private readonly productService = new ProductService();
  private readonly checkoutService = new CheckoutService();
  private readonly addressService = new AddressService();

  constructor(options?: SDKConfig) {
    const { clientId, clientSecret, apiUrl, env } = options || {};

    if (!clientId) throw new Error('clientId is required');

    Object.assign(configuration, envs[env] || envs.production);

    configuration.credentials = new Auth(clientId, clientSecret);
    configuration.apiUrl = apiUrl || configuration.apiUrl;
  }

  public async product(search: ProductSearchParams & { ids: string[] }): Promise<Product[]> {
    const { ids, ...params } = search;
    const product = await this.productService.get(ids, params);

    return product;
  }

  public async cart(params?: UpdateCart): Promise<Cart> {
    const { id, ...rest } = params || {};
    const hasParams = Object.keys(rest).length > 0;

    const isUpdate = id && hasParams;

    const cart = isUpdate
      ? await this.cartService.update(Number(id), params)
      : await this.cartService.get(Number(id));

    if (!cart) throw new Error('Cart not found');

    if (!isUpdate && hasParams) {
      const updatedCart = await this.cartService.update(cart.id, params);
      return this.cartService.mapCart(updatedCart);
    }

    return this.cartService.mapCart(cart);
  }
  /* eslint-disable */
  public async address(params: AddressSearch): Promise<Prediction[]>;
  public async address(params: AddressFetch): Promise<AddressDetails>;
  public async address(): Promise<AddressDetails>;
  public async address(params?: AddressQuery): Promise<Prediction[] | AddressDetails> {
    const { search } = params as AddressSearch;
    const { placeId } = params as AddressFetch;

    if (placeId) return await this.addressService.get({ placeId });
    if (search) return await this.addressService.search({ search });

    throw new Error('Invalid params');
  }
  /* eslint-enable */

  public async checkout(params: CreateCheckout): Promise<Checkout> {
    return await this.checkoutService.createCheckoutUrl({ ...params });
  }

  public async authenticate(): Promise<this> {
    await configuration.credentials.authenticate();
    return this;
  }
}
